import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";

const MonthDropdown = ({ title, options = [], onSelect, selectedOption }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    const toggleDropdown = () => setIsOpen((prev) => !prev);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="hs-dropdown relative" ref={containerRef}>
            <button
                onClick={toggleDropdown}
                type="button"
                className="hs-dropdown-toggle flex justify-between w-[8rem] py-3 px-4 items-center gap-x-2 text-sm sm:text-md font-medium rounded-lg border border-gray-400 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                aria-haspopup="menu"
                aria-expanded={isOpen}
            >
                {selectedOption?.name || title}
                <IoIosArrowDown
                    className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                />
            </button>

            {isOpen && (
                <div
                    className="absolute w-full z-40 bg-white shadow-md border border-gray-300 rounded-lg mt-1"
                    role="menu"
                    aria-orientation="vertical"
                >
                    <div className="p-1 space-y-0.5 max-h-60 overflow-y-auto">
                        {options.map((option) => (
                            <button
                                key={option.id}
                                onClick={() => {
                                    onSelect(option);
                                    setIsOpen(false);
                                }}
                                className="w-full flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-md text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-100"
                            >
                                {option.name}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MonthDropdown;
